/* [EZ] PDP button states — Add to Cart "Adding to cart…" loading (spinner replaces the icon,
   disabled look) until Horizon's native success checkmark shows; plus a reset-on-return so any
   button restored from the back-forward cache (e.g. Back from checkout) returns to default.
   Progressive enhancement, no core edits. Buy Now's own loading lives in ez-cart-drawer.js. */
(function () {
  var ATC_MSG = 'Adding to cart';

  function atcButtons() {
    return [].slice.call(document.querySelectorAll('.add-to-cart-button'))
      .filter(function (b) { return !b.closest('.sticky-add-to-cart'); });
  }

  function setAtcLoading(btn, on) {
    var textEl = btn.querySelector('.add-to-cart-text__content');
    if (on) {
      btn.classList.add('ez-atc-loading');
      btn.setAttribute('aria-busy', 'true');
      if (textEl && btn.dataset.ezAtcOrig == null) {
        btn.dataset.ezAtcOrig = textEl.textContent.trim();
        textEl.textContent = ATC_MSG;
      }
      if (!btn.querySelector('.ez-spin')) {
        var sp = document.createElement('span');
        sp.className = 'ez-spin';
        var holder = btn.querySelector('.add-to-cart-text') || btn;
        holder.insertBefore(sp, holder.firstChild);
      }
    } else {
      btn.classList.remove('ez-atc-loading');
      btn.removeAttribute('aria-busy');
      if (textEl && btn.dataset.ezAtcOrig != null) { textEl.textContent = btn.dataset.ezAtcOrig; delete btn.dataset.ezAtcOrig; }
      var s = btn.querySelector('.ez-spin'); if (s) s.remove();
    }
  }

  function wire() {
    atcButtons().forEach(function (btn) {
      if (btn.dataset.ezAtcWired) return;
      btn.dataset.ezAtcWired = '1';
      btn.addEventListener('click', function () {
        if (btn.disabled) return;
        setAtcLoading(btn, true);
        clearTimeout(btn._ezAtcT);
        btn._ezAtcT = setTimeout(function () { setAtcLoading(btn, false); }, 4000); // safety clear
      });
    });
  }

  // The sticky bar's button shows a success "check" via data-added; Horizon only clears it after
  // its fly-to-cart animation ends, so if that animation never fires (reduced motion / interrupted)
  // the check stays stuck. Force-clear it so the sticky button always returns to default.
  function clearStickyAdded() {
    [].forEach.call(document.querySelectorAll('.sticky-add-to-cart [data-added]'), function (el) {
      el.removeAttribute('data-added');
    });
  }

  function stickyBarEl() {
    var s = document.querySelector('sticky-add-to-cart');
    return s && s.querySelector('[ref="stickyBar"]');
  }
  function mainBuyButtonsOutOfView() {
    var main = document.querySelector('[class*="buy-buttons-block"]:not(.sticky-add-to-cart *)');
    if (!main) return false;
    var r = main.getBoundingClientRect();
    return r.bottom < 0 || r.top < 0; // scrolled past → the sticky bar is meant to be showing
  }
  // After an add from the sticky bar, the bar must STAY visible (it was vanishing and only came
  // back on scroll). For a short window, if something flips data-stuck off while the main buy
  // buttons are still scrolled out of view, force it back so the bar doesn't disappear.
  function keepStickyVisible() {
    var bar = stickyBarEl();
    if (!bar || bar.getAttribute('data-stuck') !== 'true') return; // wasn't showing → leave it
    var reassert = function () {
      var b = stickyBarEl();
      if (b && b.getAttribute('data-stuck') !== 'true' && mainBuyButtonsOutOfView()) {
        b.setAttribute('data-stuck', 'true');
      }
    };
    var mo = new MutationObserver(reassert);
    mo.observe(bar, { attributes: true, attributeFilter: ['data-stuck'] });
    setTimeout(reassert, 400);   // fallback if the bar element was replaced
    setTimeout(reassert, 1300);
    setTimeout(function () { mo.disconnect(); }, 2000);
  }

  // Horizon fires cart:update when the item is added → clear loading; its native checkmark-burst
  // then plays for the success feel.
  document.addEventListener('cart:update', function () {
    atcButtons().forEach(function (btn) { clearTimeout(btn._ezAtcT); setAtcLoading(btn, false); });
    keepStickyVisible();                // keep the sticky bar shown after a sticky add
    setTimeout(clearStickyAdded, 1200); // let the check show briefly, then reset to default
  });

  // Reset EVERY [EZ] button to default whenever the page is shown (normal nav AND bfcache Back),
  // plus a tick later as a safety net — so a button never comes back frozen in loading/disabled.
  function resetAll() {
    atcButtons().forEach(function (btn) { clearTimeout(btn._ezAtcT); setAtcLoading(btn, false); });
    clearStickyAdded();
    var bn = document.querySelectorAll('.ez-buynow-block__btn.is-loading, [data-ez-buy-now].is-loading');
    [].forEach.call(bn, function (el) { if (window.ezSetBuyNowLoading) window.ezSetBuyNowLoading(el, false); });
  }
  window.addEventListener('pageshow', function () { resetAll(); setTimeout(resetAll, 50); });

  function start() { wire(); setTimeout(wire, 100); } // re-wire after the buy-row hoist runs
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
